<div class="brand__details" [ngClass]="INDRA_featureListClasses()">
    <!-- <button
		*ngIf="INDRA_showEconomyExtra()" class="brand__details-economyxtra" 
		(click)="INDRA_handleClickOpenEconomyxtraDetails()" tabindex="0" [attr.aria-label]="'availability.flightsPage.aria.economyExtraOpen' | ibeadmin | async">
		<app-svg 
			class="brand__details-economyxtra__logo" 
			svg="sprite.svg#logo--economy_extra--white"
			[attr.aria-label]="'availability.flightsPage.aria.economyExtraBrand' | ibeadmin | async" 
			[alt]="'availability.flightsPage.alt.economyExtraBrand' | ibeadmin | async">
		</app-svg>
		<app-svg 
			class="brand__details-economyxtra__info" 
			svg="icons.svg#general--information" 
			[alt]="'availability.flightsPage.alt.informationIcon' | ibeadmin | async"
			aria-hidden="true">
		</app-svg>
	</button> -->

    <!-- Headrest image -->
    <!-- <div class="brand__features-image-wrapper" *ngIf="displayBrandImage">
		<img [ngClass]="{'brand__features-image--unavailable': !INDRAisBrandAvailable() }" 
			class="brand__features-image" 
			[attr.src]="INDRA_getBrandImage()" 
			[alt]="INDRA_brandName + ' image'">
	</div> -->

	<div [ngClass]="{'brand_selected_border': isSelected }">
        <div class="brand__name">
            <app-svg [ngClass]="['brand--'+INDRA_brandName]" svg="sprite.svg#brand--{{INDRA_brandName}}" attr.aria-label="{{INDRA_brandName + ' brand for ' + INDRA_printPrice}}" [alt]="INDRA_brandName + ' logo'">
            </app-svg>
            <span class="text-link fright" (click)="INDRA_handleTicketConditionsClick($event)">{{ 'bookingDetails.label.fareConditions' | ibeadmin | async }}</span>
        </div>
		<div class="brand-extras-box">
			<div class="brand-toggle-box" (click)="INDRA_handleClickToggleExpandFeatures()" >
				<span>{{'availability.flightsPage.aria.isIncluded' | ibeadmin | async}}</span>
				<app-svg class="brand__features-expand-icon" svg="icons.svg#general--arrow--bottom" [alt]="'availability.flightsPage.alt.collapseFeaturesList' | ibeadmin | async"></app-svg>
			</div>
			<ul *ngIf="ancillariesList" class="brand__features-list" attr.aria-label="{{INDRA_brandName + ' features'}}">

				<li class="brand__feature brand__feature--economyxtra" (click)="INDRA_handleClickOpenEconomyxtraDetails()" [attr.aria-label]="'availability.flightsPage.aria.economyExtraOpen' | ibeadmin | async" *ngIf="INDRA_showEconomyExtra()">
					<span class="feature__title">
						{{ 'availability.flightsPage.text.upToFiveExtras' | ibeadmin | async }}
					</span>
					<a class="link" [attr.aria-label]="'availability.flightsPage.aria.economyExtraOpen' | ibeadmin | async" href="javascript:;">
						{{ 'availability.flightsPage.text.learnMore' | ibeadmin | async }}
					</a>
				</li>

				<ng-container *ngFor="let feature of features">
					<li *ngIf="feature.amountLabel || feature.includedAncillaries.length" class="brand__feature" [ngClass]="INDRA_featureType(feature)" [tooltip]="INDRA_capitalizeFirstLetter(feature['toolTip'])">
						<button (click)="INDRA_handleClickFeature(feature)">
							<app-svg svg="icons.svg#{{INDRA_featureIcon(feature)}}" class="feature__icon" aria-hidden=true [alt]="'availability.flightsPage.text.' + INDRA_featureLabel(feature) | ibeadmin | async">
							</app-svg>
							<p class="feature__label">
								<span *ngIf="INDRA_featureIsAdded(feature) && feature.amountLabel">
									{{ feature.amountLabel + (feature.code === BAG_ANCILLARY_CODE ? ' x ' : ' ') }}
								</span> {{ 'availability.flightsPage.text.' + INDRA_featureLabel(feature) | ibeadmin | async}}
								<!--
<span class="icon-extra" *ngIf="INDRA_featureExtra(feature)">
<app-svg class="icon-extra--svg" 
svg="sprite.svg#{{INDRA_featureExtra(feature).icon}}"
alt='{{INDRA_featureLabel(feature).label}}'>
</app-svg>
</span>
-->
							</p>
							<app-svg *ngIf="INDRA_featureIsAdded(feature)" class="right check" style="color:#127045" svg="icons.svg#check-in--check-in" [attr.aria-label]="'availability.flightsPage.aria.isIncluded' | ibeadmin | async" [alt]="'availability.flightsPage.alt.isIncludedIcon' | ibeadmin | async">
							</app-svg>
							<p *ngIf="INDRA_featureIsAvailable(feature)" class="feature__price">
								<!-- <span class="feature__price--prefix">{{'availability.flightsPage.text.from' | ibeadmin |async}}</span> 
{{INDRA_featurePrice(feature) | indracurrency: INDRA_getCurrency(feature)}} -->
								<span class="feature__price--prefix">{{'availability.flightsPage.text.chargeable' | ibeadmin |async}}</span>
							</p>
						</button>
					</li>
				</ng-container> 
			</ul>
		</div>
        <div class="brand__features-list no-margin" *ngIf="!ancillariesList">
            <app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
            <app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
            <app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
            <app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
            <app-loading-shadow [height]="'2rem'" class="bottom-gap"></app-loading-shadow>
        </div>

    </div>

    <!-- <div class="brand__select--mobile" aria-hidden="true">
		<button class="button button-accent button--icon-right" (click)="INDRA_handleClickSelectConfirm()">Select this
			flight<app-svg svg="icons.svg#general--arrow--right" aria-hidden="true" [alt]="'Arrow icon'"></app-svg></button>
	</div> -->
</div>

<div  class="brand__select" [ngClass]="{'brand_select': brand.name !== selectedBrand, 'brand_selected': brand.name === selectedBrand}" tabindex="0" role="button" attr.aria-label="{{'Select ' + INDRA_brandName + ' brand for ' + (INDRA_printPrice | indracurrency) }}">
    <span class="brand__price" aria-hidden="true">
        <p class="brand__price-value">
            {{INDRA_printPrice | indracurrency }}
            <span *ngIf="bookAwardFlights">{{INDRA_getTax()}}</span>
        </p>
    </span>
    <div *ngIf="brand.name !== selectedBrand">
        <button class="button button--icon button--small " aria-hidden="true" (click)="INDRA_handleClickSelectConfirm()" >{{ 'availability.flightsPage.text.select' | ibeadmin | async}}</button>
    </div>
    
    <div *ngIf="brand.name === selectedBrand " class="brand__status_container">
        <span class="brand__status_label">{{ 'availability.flightsPage.text.selected' | ibeadmin | async}}</span>
        <app-svg class="right check" svg="sprite.svg#flight--brand-checked" aria-label='is selected' alt='Is included icon'></app-svg>
    </div>
</div>

<div class="flight-note muted" *ngIf="INDRA_showWarning(0)">
    <app-svg class="flight-note__icon" svg="icons.svg#general--information" [alt]="'availability.flightsPage.alt.informationIcon' | ibeadmin | async" aria-hidden="true"></app-svg>
    <span>
		{{ 'availability.flightsPage.text.flightsOperatesInExec' | ibeadmin | async }} ({{firstClassFlightSegmentNumbers}}).
	</span>
</div>
